import api from '../../api';

export default {
    namespaced: true,
    state: {
        termsData: []
    },
    getters: {
        getTermsData(state) {
            return state.termsData;
        }
    },
    mutations: {
        SetTermsData(state, data) {
            state.termsData = data;
        }
    },
    actions: {
        fetchTermsData({ commit }) {
            api().get(`termsOfUse/getAll`, {
                headers: {
                    'Authorization': localStorage.getItem("JwtToken")
                }
            })
                .then(res => {
                    commit("SetTermsData", res.data.data);
                })
                .catch(err => {
                    console.error("Error fetching terms defaults", err);
                })
        },
        addTermsData({ dispatch }, content) {
            return new Promise((resolve) => {
                api().post(`termsOfUse/add`, 
                    {
                        header_ar: content.header_ar,
                        header_en: content.header_en,
                        content_ar: content.content_ar,
                        content_en: content.content_en,
                        active_f: content.active_f
                    }, {
                    headers: {
                        'Authorization': localStorage.getItem("JwtToken")
                    }
                })
                .then(res => {
                    if (res.status == 200 || res.status == 201) {
                        resolve(res);
                        dispatch("fetchTermsData");
                    } else {
                        resolve({ status: res.data?.status, message: res.data?.message });
                    }
                })
                .catch(err => {
                    resolve({ status: 'error', message: err.message });
                });
            });
        },
        editTermsData({ dispatch }, content) {
            return new Promise((resolve) => {
                api().post(`termsOfUse/edit`, 
                    {
                        id: content.id,
                        header_ar: content.header_ar,
                        header_en: content.header_en,
                        content_ar: content.content_ar,
                        content_en: content.content_en,
                        active_f: content.active_f
                    }, {
                    headers: {
                        'Authorization': localStorage.getItem("JwtToken")
                    }
                })
                .then(res => {
                    if (res.status == 200 || res.status == 201) {
                        resolve(res);
                        dispatch("fetchTermsData");
                    } else {
                        resolve({ status: res.data?.status, message: res.data?.message });
                    }
                })
                .catch(err => {
                    resolve({ status: 'error', message: err.message });
                });
            });
        }
    }
}
